
import { message, Button, Flex } from 'antd';
import { updateFllow } from "@/apis/user";
import profile from "@/assets/images/profile.png";
import styles from "./index.module.scss"
import intl from "react-intl-universal";
import { useNavigate } from "react-router-dom";

const UserCard = ({ info, interact, pUuid }) => {
	const navigate = useNavigate();

	// 取消关注
	const cancelFollow = () => {
		updateFllow(info.uuid, "delete").then(res => {
			message.success("取消成功");
			interact(info.uuid, "followedByMe", false);
		})
	}

	// 关注
	const follow = () => {
		updateFllow(info.uuid, "get").then(res => {
			message.success("关注成功");
			interact(info.uuid, "followedByMe", true);
		})
	}
	const Bnt = () => {
		if (info.followedByMe) {
			// 我关注了他---取关
			return <Button onClick={cancelFollow} size="small" type="primary">{intl.get("User.Unfollow")}</Button>
		} else {
			// 我没有关注他---回关、取关
			return <Button onClick={follow} size="small" type="primary">{info.followsMe ? intl.get("User.Follow back") : intl.get("User.Follow")}</Button>
		}
	}
	return <Flex key={info.uuid} className={styles.flexBox} justify="space-between">
		<Flex className={styles.leftBox}>
			<img
				className={styles.profile}
				alt="basic"
				onClick={() => {
					navigate("/user/?uuid=" + info.uuid);
				}}
				src={info.avatar ? process.env.REACT_APP_API_AFFIX + "/file/preview?filePath=" + info.avatar.filePath : profile}
			/>
			<div className={styles.infoBox}>
				<div className={styles.name}>
					{info.nickname}
				</div>
				<div className={styles.desBox}>{info.signature || "暂无签名..."}</div>
			</div>
		</Flex>
		{
			info.uuid !== pUuid && <Bnt />
		}
	</Flex>
}
export default UserCard;